module.exports = __webpack_public_path__ + "img/rvdsb-1@small-2.7dcc22ac.png";